

























import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'dialog'
})
export default class DialogSlot extends Vue {
  @Prop({ required: false }) private title!: string
  @Prop({ default: '30%' }) private width!: string
  //   @Prop({ required: false }) private tip!: string
  @Prop({ required: true }) private show!: boolean
  @Prop({ required: false }) private rightHide!: boolean
  @Prop({ required: false, default: '是' }) private leftText!: string
  @Prop({ required: false, default: '否' }) private rightText!: string
  @Prop({ required: false, default: false }) private  showClose!: boolean
}

